export const LoadingType = {
    SMALL: 'small',
    LARGE: 'large',

    DOTS: 'dots'
};